// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db } from '@/shared/firebase/firebase-init';
const KEY_TEAM_MANAGER = 'teamManagers'

export default {
  list(id) {
    return new Promise((resolve) => {
      db.ref("log")
        .child("logs")
        .child(KEY_TEAM_MANAGER)
        .orderByChild("id")
        .equalTo(id)
        .once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });

        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/team-manager/team-manager-history/team-manager-history-single/team-manager-history-single-service.js